// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\GoogleCalendarSendFutureBookingsResponse

export type GoogleCalendarSendFutureBookingsApiResponse = {
	sentCount: number;
	success: boolean;
};

export type GoogleCalendarSendFutureBookings = {
	sentCount: number;
	success: boolean;
};

export function hydrateGoogleCalendarSendFutureBookings(data: GoogleCalendarSendFutureBookingsApiResponse): GoogleCalendarSendFutureBookings {
	return { ...data };
}